import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import { stepAtom } from '../atoms';
import { Steps } from '../BuildBundle.enum';
import { Step } from '../constants';
import { useBabSanity } from './context';

export const useBack = () => {
  const router = useRouter();
  const [step] = useAtom(stepAtom);
  const { onClose } = useBabSanity();

  const handleBack = () => {
    if (step === Step.FIRST_STEP) {
      onClose?.();
    } else if (step === Step.SECOND_STEP) {
      // Remove type and update step when going back
      const query = { ...router.query };
      delete query.type;
      query.step = Steps.FIRST_STEP.toString();

      router.replace({
        pathname: router.pathname,
        query
      });
    }
  };

  return { handleBack };
};
